module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "room-view",
    class: [{
      disable: !_vm.room.avaliable,
      empty: _vm.empty,
      delegated: _vm.delegated
    }, "expiring-level" + _vm.level],
    on: {
      "click": _vm.goto
    }
  }, [_c('div', {
    staticClass: "no"
  }, [_vm._v(_vm._s(_vm.room.no))]), _c('div', {
    staticClass: "right-corner-icons"
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "disabled": _vm.$media.isMobile || !_vm.tracking_notes_unchecked.length
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.tracking_notes_unchecked), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('span', [_vm._v(_vm._s(item.note))])])
  })), _c('div', {
    staticClass: "quick-note",
    class: {
      active: _vm.tracking_notes_unchecked.length
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit("tracking-notes", _vm.room)
      }
    }
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.tracking_notes_unchecked.length ? "sticky note" : "sticky note outline"
  })])]), (_vm.contract && _vm.contract.preorderable === 1) ? _c('div', {
    staticClass: "preorderable",
    attrs: {
      "data-tooltip": "可预订",
      "data-position": "top center",
      "data-inverted": ""
    }
  }, [_c('i', {
    staticClass: "icon pin"
  })]) : _vm._e(), (_vm.contract && _vm.contract.preorderable === 2) ? _c('div', {
    staticClass: "preorderable",
    attrs: {
      "data-tooltip": "确认续租",
      "data-position": "top center",
      "data-inverted": ""
    }
  }, [_c('i', {
    staticClass: "icon checkmark"
  })]) : _vm._e(), (_vm.persons) ? _c('div', {
    staticClass: "persons",
    attrs: {
      "data-tooltip": _vm.$media.isMobile ? null : _vm.$formatters.customers_summary(_vm.customers),
      "data-position": "top center",
      "data-inverted": ""
    }
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v(_vm._s(_vm.persons > 1 ? 'people' : 'person'))]), _c('span', [_vm._v(_vm._s(_vm.persons))])]) : _vm._e()], 1), _c('div', {
    staticClass: "prices",
    class: {
      shifted: _vm.preorders.length
    }
  }, [_c('div', {
    staticClass: "per_month"
  }, [_vm._v(_vm._s(_vm.room.price_month))])]), (!_vm.contract && _vm.$permission.has("basic.view.rooms.empty_days")) ? _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "mi",
    attrs: {
      "data-tooltip": "空置时间",
      "data-position": "left center",
      "data-inverted": ""
    }
  }, [_vm._v("event_seat")]), _c('span', {
    attrs: {
      "data-tooltip": _vm.$formatters.date.to_date(_vm.last_contract_end),
      "data-position": "right center",
      "data-inverted": ""
    }
  }, [_vm._v(_vm._s(_vm.empty_days) + " 天")])]) : _vm._e(), (_vm.contract) ? [(_vm.delegated) ? _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "mi",
    attrs: {
      "data-tooltip": "委托到期时间",
      "data-position": "left center",
      "data-inverted": ""
    }
  }, [_vm._v("transfer_within_a_station")]), _c('span', {
    attrs: {
      "data-tooltip": _vm.$formatters.date.to_date(_vm.contract.transfer_delegation.date_end),
      "data-position": "right center",
      "data-inverted": ""
    }
  }, [_vm._v("委托: " + _vm._s(_vm.days_to_delegation_end) + " 天")])]) : (!_vm.rent_paid_off) ? _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "mi",
    attrs: {
      "data-tooltip": "租金到期时间",
      "data-position": "left center",
      "data-inverted": ""
    }
  }, [_vm._v("schedule")]), _c('span', {
    attrs: {
      "data-tooltip": _vm.$formatters.date.to_date(_vm.date_expire),
      "data-position": "right center",
      "data-inverted": ""
    }
  }, [_vm._v(_vm._s(_vm.$formatters.date.expiring_text_from_now(_vm.date_expire)))])]) : (_vm.rent_paid_off) ? _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "mi",
    attrs: {
      "data-tooltip": "合同到期时间",
      "data-position": "left center",
      "data-inverted": ""
    }
  }, [_vm._v("event_note")]), _c('span', {
    attrs: {
      "data-tooltip": _vm.$formatters.date.to_date(_vm.contract.date_end),
      "data-position": "right center",
      "data-inverted": ""
    }
  }, [_vm._v(_vm._s(_vm.$formatters.date.expiring_text_from_now(_vm.contract.date_end)))])]) : _vm._e()] : _vm._e(), (_vm.preorders.length) ? [_c('div', {
    staticClass: "preorder"
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4840f87c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/RoomView.vue
// module id = 326
// module chunks = 0